import { Injectable } from '@angular/core';
import { TenantDto, TenantsService } from '@careapp-group/ng-sdk-v2-new';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CAAction, Tenants } from '../actions';

@Injectable()
export class TenantsEffects {
  requestTenants$ = createEffect((): any =>
    this.actions$.pipe(
      ofType(Tenants.REQUEST_ALL),
      switchMap((action) =>
        this.tenantsService.getTenants({}).pipe(
          map((items: TenantDto[]) => Tenants.ResponseSuccessAllAction(items)),
          catchError((error) => of(Tenants.ResponseFailAllAction({ error })))
        )
      )
    )
  );
  createTenant$ = createEffect((): any =>
    this.actions$.pipe(
      ofType(Tenants.REQUEST_CREATE),
      switchMap((action) =>
        this.tenantsService.createTenant({ tenantRequestDto: action.payload }).pipe(
          map((response) => Tenants.ResponseSuccessCreateAction(response)),
          catchError((error) => of(Tenants.ResponseFailCreateAction({ error })))
        )
      )
    )
  );
  saveTenant$ = createEffect((): any =>
    this.actions$.pipe(
      ofType(Tenants.REQUEST_SAVE),
      switchMap((action) =>
        this.tenantsService
          .updateTenant({ id: action.payload.id, updateTenantRequestDto: action.payload.data })
          .pipe(
            map((response) => Tenants.ResponseSuccessSaveAction(response)),
            catchError((error) => of(Tenants.ResponseFailSaveAction({ error })))
          )
      )
    )
  );

  constructor(private actions$: Actions<CAAction>, private tenantsService: TenantsService) {}
}
